// pages/Users/ManageUsers.js
import React, { useState, useEffect } from "react";
import ListUsers from "./ListUsers";
import AddUser from "./AddUser";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

const fontFamily = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";

const colors = {
  textPrimary: '#1e293b',
  textSecondary: '#475569',
  textTertiary: '#94a3b8',
  accent: '#8b5cf6',
};

export default function ManageUsers() {
  const [activeTab, setActiveTab] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    document.title = "Manage Users | KlonIT Web Application";
  }, []);

  const handleChange = (event, newValue) => setActiveTab(newValue);
  const triggerRefresh = () => setRefresh((prev) => !prev);

  const tabItems = [
    { label: 'List Users', icon: <FormatListBulletedIcon sx={{ fontSize: '1.1rem' }} /> },
    { label: 'Add User', icon: <PersonAddOutlinedIcon sx={{ fontSize: '1.1rem' }} /> },
  ];

  return (
    <Box sx={{ fontFamily, maxWidth: '1200px', width: '100%', mx: 'auto' }}>
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Box sx={{
          width: 56,
          height: 56,
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
          boxShadow: '0 8px 24px rgba(139,92,246,0.3)',
        }}>
          <PeopleOutlineIcon sx={{ color: '#fff', fontSize: 28 }} />
        </Box>
        <Typography sx={{ fontFamily, fontSize: '1.5rem', fontWeight: 700, color: colors.textPrimary, letterSpacing: '-0.02em' }}>
          Manage Users
        </Typography>
        <Typography sx={{ fontFamily, fontSize: '0.875rem', color: colors.textTertiary, mt: 0.5 }}>
          Add, edit, and manage team members and their access
        </Typography>
      </Box>

      {/* Main Content */}
      <Box sx={{
        bgcolor: 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(12px)',
        borderRadius: '16px',
        border: '1px solid rgba(0,0,0,0.06)',
        overflow: 'hidden',
      }}>
        {/* Tabs */}
        <Box sx={{
          borderBottom: '1px solid rgba(0,0,0,0.06)',
          bgcolor: 'rgba(139,92,246,0.03)',
        }}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            sx={{
              px: 2,
              '& .MuiTab-root': {
                fontFamily,
                fontSize: '0.875rem',
                fontWeight: 500,
                textTransform: 'none',
                minHeight: 56,
                px: 3,
                color: colors.textSecondary,
                '&:hover': { color: colors.accent },
                '&.Mui-selected': {
                  color: colors.accent,
                  fontWeight: 600,
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: colors.accent,
                height: 3,
                borderRadius: '3px 3px 0 0',
              },
            }}
          >
            {tabItems.map((item, index) => (
              <Tab
                key={index}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {item.icon}
                    {item.label}
                  </Box>
                }
              />
            ))}
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ p: 3 }}>
          {activeTab === 0 && <ListUsers refresh={refresh} onRefresh={triggerRefresh} />}
          {activeTab === 1 && <AddUser onRefresh={triggerRefresh} />}
        </Box>
      </Box>
    </Box>
  );
}
